import { Paper, PaperProps, Typography, styled } from "@mui/material";
import { MapContainer, WMSTileLayer } from "react-leaflet";

import { useLanduseLayer, useMapPosition } from "hooks/mapHooks";

import { MeasureConf, StudyArea } from "types/types";

import { DrawResult } from "./DrawResult";
import { RenderBackgroundLayer } from "components/map/layers/RenderBackgroundLayer";
import { AttributionAndScale } from "components/map/attribution/AttributionAndScale";
import { useTranslation } from "react-i18next";

interface Props extends PaperProps {
  measureConfigs: MeasureConf[];
  studyArea: StudyArea;
  uuid?: string;
}

export function LeafletMap(props: Props) {
  const { measureConfigs, studyArea, uuid, ...paperProps } = props;
  const { t } = useTranslation();
  const landuseLayer = useLanduseLayer();
  const { zoom, lat, lng } = useMapPosition();

  return (
    <StyledPaper {...paperProps}>
      <Typography variant="h2" component="h2">
        {t("label.onMap")}
      </Typography>
      <MapContainer
        zoomControl={false}
        center={[lat, lng]}
        zoom={zoom}
        scrollWheelZoom={false}
        doubleClickZoom={false}
        dragging={false}
        attributionControl={false}
      >
        <DrawResult measureConfigs={measureConfigs} studyArea={studyArea} />
        <RenderBackgroundLayer />
        {landuseLayer && (
          <WMSTileLayer
            key={landuseLayer.id}
            {...landuseLayer.wms}
            zIndex={1}
            opacity={0.5}
          />
        )}

        <AttributionAndScale position="bottomright" uuid={uuid} />
      </MapContainer>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  max-height: ${({ theme }) => theme.spacing(70)};
  gap: ${({ theme }) => theme.spacing(2)};
  .leaflet-right .leaflet-control.flush-to-edge {
    margin-right: 0px;
  }
  .leaflet-bottom .leaflet-control.flush-to-edge {
    margin-bottom: 0px;
  }
  .leaflet-left .leaflet-control.flush-to-edge {
    margin-left: 0px;
  }
  .leaflet-top .leaflet-control.flush-to-edge {
    margin-top: 0px;
  }
  .leaflet-container {
    height: 100%;
    width: 100%;
  }
`;
